import { render, staticRenderFns } from "./MedicalMedicalH.vue?vue&type=template&id=554bc7ba&scoped=true"
import script from "./MedicalMedicalH.vue?vue&type=script&lang=js"
export * from "./MedicalMedicalH.vue?vue&type=script&lang=js"
import style0 from "./MedicalMedicalH.vue?vue&type=style&index=0&id=554bc7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554bc7ba",
  null
  
)

export default component.exports